// Copyright (c) 2021 Deere & Company

import './index.scss';

import AtpReallocation from './atpReallocation';
import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';

function AtpReallocationPage () {

    return (
        <AuthenticatedPage className="atp-page atp-reallocation-page">
            <AtpReallocation />
        </AuthenticatedPage>
    );

}
AtpReallocationPage.displayNAme = 'AtpReallocationPage';

export default AtpReallocationPage;
